import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';
import { AppContextProvider, Env } from '@contexts/AppContext';
import { SearchScope } from '@hooks/useSearchResults';
import { User } from '@utils/backend-api/currentUser';

import SearchContent from './Content';

const queryClient = new QueryClient();

interface TopEntity {
  id: number;
  name: string;
  following: boolean;
}

interface TopRelatedEntity {
  matchingEntity: boolean;
  name: string;
}

export interface SearchPageProps {
  articleContent: ArticleOrBriefing[];
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isSignedIn: boolean;
  isWebview: boolean;
  page: number;
  pageCount?: number;
  query?: string;
  scope: SearchScope;
  title: string;
  topEntities?: Array<TopEntity>;
  topRelatedEntities: Array<TopRelatedEntity>;
}

const SearchPage = (props: SearchPageProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <SearchContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default SearchPage;
